/* Imports */
import React from "react"
import { Breadcrumbs } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const BreadcrumbsPage = () => {
    const breadcrumbsItems = [
        {
            text: "Link",
            to: "#",
        },
        {
            text: "Link",
            to: "#",
        },
        {
            text: "Link",
            to: "#",
        },
        {
            text: "Active",
        },
    ]

    const items = [
        {
            title: "With a slash",
            content: <Breadcrumbs items={breadcrumbsItems} separator="slash" color="secondary" />,
            code: 'const breadcrumbsItems = [\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Active",\n    },\n]\n\n<Breadcrumbs items={breadcrumbsItems} separator="slash" color="secondary" />',
        },
        {
            title: "With an icon",
            content: <Breadcrumbs items={breadcrumbsItems} separator="icon" color="danger" />,
            code: 'const breadcrumbsItems = [\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Active",\n    },\n]\n\n<Breadcrumbs items={breadcrumbsItems} separator="icon" color="danger" />',
        },
    ]

    const propsItems = [
        {
            name: "items",
            type: "Array of objects",
            required: "Yes",
        },
        {
            name: "text (item Object)",
            type: "String",
            example: "Homepage",
            required: "Yes",
        },
        {
            name: "to (item Object)",
            type: "String",
            example: "/",
        },
        {
            name: "separator",
            type: "String",
            example: "chevron",
            possible: '"slash" | "icon"',
            default: "slash",
        },
        {
            name: "color",
            type: "String",
            example: "success",
            possible: commonProps.colorsHover,
            default: "primary",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default BreadcrumbsPage
